import React from 'react'

export default function(state, payload) {
  localStorage.removeItem('session-token');
  localStorage.removeItem('session-usrid');
  return {...state, data: null, logged: false, logging:false, failure: false};
}
